import { Footer } from '@shared/layout/DefaultPage'
import { Inline } from '@shared/layout/Inline'
import { BlueTransparentButton } from '@shared/styles/BlueTransparentButton'
import { SwipeButton } from '@ui/SwipeButton'
import { useIonRouter, UseIonRouterResult } from '@ionic/react'
import { ROUTES } from '@shared/constants/routes'
import { useParams } from 'react-router'
import { useQueryParam } from '@shared/hooks/useQueryParams'

export const ResultFooter = () => {
	const nav: UseIonRouterResult = useIonRouter()
	const { programId } = useParams<{ programId: string }>()
	const trainingType = useQueryParam('training')
	const goToReviewPage = () => {
		nav.push(ROUTES.overall.review)
	}

	const goFromTraining = () => {
		const path = trainingType === 'training' ? ROUTES.overall.main : `/program/${programId}`
		nav.push(path)
	}

	return (
		<Footer>
			<Inline justify={'space-between'}>
				<BlueTransparentButton width={173} onClick={goToReviewPage}>
					Оставить отзыв
				</BlueTransparentButton>
				<SwipeButton
					width={173}
					onClick={goFromTraining}
					title={'Следующее'}
					moveTextLeft={-0}
				/>
			</Inline>
		</Footer>
	)
}
